
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { DashboardCount } from '../models';
import { ApiService } from './api.service';
import { JwtService } from './jwt.service';


@Injectable()
export class AdminService {

  constructor(
    private router: Router,
    private apiService: ApiService,
    private jwtService: JwtService
  ) { }

  getAllHospital(): Observable<[string]> {
    return this.apiService.get('/api/v2/admin/hospital/H')
      .map(data => data);
  }


  getAllPracticeList(): Observable<[string]> {
    return this.apiService.get('/api/v2/admin/hospital/P')
      .map(data => data)
  }

  getDashboardCount(): Observable<DashboardCount> {
    return this.apiService.get('/api/v2/admin/dashboardcount')
      .map(data => data)
  }

  getDocumentByType(type): Observable<any> {
    return this.apiService.get('/api/v2/admin/managelibrary/' + type)
  }

  getDocumentByHospital(type, hospital): Observable<any> {
    return this.apiService.get(`/api/v2/admin/getLibraryDataByHospital/${hospital}/${type}`)
  }

  getUserList(type): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/useraccounttype/${type}`)
  }
  getMapList(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getAssociatedHospitals/${id}`)
  }
  getHospital(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getMapHospital/${id}`)
  }
  getmapcode(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getMapCountryCode/${id}`)
  }
  getmapsnf(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/fetchSnfFollowupMasterList/${id}`)
  }


  getUserListByHospital(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getUsersByHospital/${id}`)
  }

  getReportList(type): Observable<any> {
    let self = this;
    return self.apiService.get('/api/v2/admin/reportList/' + type)
  }

  getPracticeList(): Observable<any> {
    let self = this;
    return self.apiService.get('/api/v2/admin/getPracticeList')
  }


  getWorkflowLsit(type, filter): Observable<any> {
    let self = this;
    if (filter == 'all') {
      return self.apiService.get(`/api/v2/admin/workflowList/${type}`)
    } else {
      return self.apiService.get(`/api/v2/admin/workflow/swiftype/${filter}`)
    }
  }



  hospitalWorkflowLsit(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getWorkflowByHospital/${id}`)
  }

  getEditWorkFlowId(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getEditWorkFlowId/${id}`)
  }

  updategetEditWork(data): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/getInsertEditWorkFlow`, data)
  }
  getServicelineLsit(type): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/workflowList/${type}`)
  }
  getService(type, id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getEditServiceline/${type}/${id}`)
  }
  getServices(type): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getEditManageServiceline/${type}`)
  }

  getServiceline(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getServiceLineByHospital/${id}`)
  }

  getdischarge(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getDischargeByHospital/${id}`)
  }

  getWorkflowFilter(): Observable<any> {
    let self = this;
    return self.apiService.get('/api/v2/admin/workflow/swiftype');
  }

  getWorkflowStages(workflowId): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/workflow/tab/${workflowId}`)
  }

  getStagesMaterials(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/workflow/tabdetails/${id}`)
  }

  addUser(User): Observable<any> {
    let self = this;
    return self.apiService.post('/api/v2/admin/saveuseraccount', User)
  }

  addUserToHospital(User): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/admin/getSaveUser`, User)
  }
  addservice(line): Observable<any> {
    let self = this;
    return self.apiService.post('/api/v2/admin/serviceline/create', line)
  }

  addhosp(id, desp): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/admin/saveHospital/${id}`, desp)
  }
  adddischarge(add): Observable<any> {
    let self = this;
    return self.apiService.post('/api/v2/admin/getSaveDischargeDetails', add)
  }
  addmap(add): Observable<any> {
    let self = this;
    return self.apiService.post('/api/v2/admin/getSaveMapHospital', add)
  }
  addcode(add): Observable<any> {
    let self = this;
    return self.apiService.post('/api/v2/admin/getSaveCountryCodeDetails', add)
  }
  addsnf(add, snf): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/admin/saveHospitalSnfFollowup/${add}`, snf)
  }

  editUser(id, user): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/updateUserAccount/${id}`, user)
  }
  editUserByHospital(user): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/getUpdateUserDetails`, user)
  }


  saveline(user): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/GetInsertEditServiceline`, user)
  }

  savehospital(user): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/getEditHospital`, user)
  }
  availid(id): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/getAvailSecByPracticeID/${id}`)
  }
  availdis(id): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/getDisableAvailSecByPracticeID/${id}`)
  }
  availuserid(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/initiateResetUserPwd/${id}`)
  }
  savelines(user): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/GetInsertManageEditServiceline`, user)
  }
  savedischarge(user): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/getUpdateDischargeDetails`, user)
  }
  getHospitalSnfFollowupMapList(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/fetchHospitalSnfFollowupList/${id}`)
  }
  getHospitalcode(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getCountryCodeByHospital/${id}`)
  }

  getChartsData(): Observable<any> {
    let self = this;
    return self.apiService.get('/api/v2/admin/dashboard');
  }

  changePassword(data, uid): Observable<any> {
    let self = this;
    return self.apiService.post(`/changepassword/${uid}?oldPassword=${encodeURIComponent(data.oldPassword)}&newPassword=${encodeURIComponent(data.newPassword)}&confirmPassword=${encodeURIComponent(data.confirmPassword)}`)
  }

  getAdminDetails(): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getUserDetails`)
  }

  updateAdminProfile(id, user): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/updateUserProfile/${id}`, user)
  }

  getworkflowmaterial(type): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/materialForWorkflow/${type}`)
  }
  getMasterstage(): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/fetchMasterStageDetails`)
  }

  createNewWorkflow(data): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/admin/workflow/create`, data)
  }

  getHospitalDashboard(id): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getpatientByHospital/${id}`)
  }




  editworkflowDetails(workflow): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/workflow/updateNameAndDesc`, workflow)
  }

  getMatrialUserRoles(): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/materialLibrary/fetchUserRole`)
  }

  getDerivedDocuments(): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/manageLibrary/fetchAllFormForDropdownList`)
  }

  uploadvideo(data): Observable<any> {
    let self = this;
    return self.apiService.fileupload(`/api/v2/admin/manageLibrary/createManaegLibraryVideo`, data)
  }

  addmaterial(data): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/admin/manageLibrary/createManaegLibraryForm`, data)
  }

  changeDocStatus(data): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/admin/admin/movetolibrary?formId=${data.formId}&productId=${data.productId}`)
  }


  getallmenu(): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/menu/getAll`)
  }
  rowdata(): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/menuConfiguration/getAll`)
  }

  updatemenu(data): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/updatemenuConfiguration`, data)
  }

  editLibrary(data): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/updateManageLibraryMaterials`, data)
  }
  setDefaultWorkflow(data): Observable<any> {
    let self = this;
    return self.apiService.put(`/api/v2/admin/getSetDefaultWorkflowByHospitalId`, data)
  }
  showsercvices(): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/workflowList/serviceline`)
  }
  showparatics(): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/hospital/p`)
  }

  getmutipledata(id, mode): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/workflow/fetchWorkflowByClientServiceline/${id}/${mode}`)
  }


  postworkflowlist(data, id): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/admin/workflow/createHospitalOrPracticeWorkflowList/${id}`, data)
  }
  getservicelinecodeExist(scode): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/serviceline/getServicelineCodeExists/${scode}`)
  }
  gethospitalcodeExist(hcode): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/getHospitalCodeExists/${hcode}`)
  }

  saveHospitalOrpracticeWorkflow(data): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/admin/workflow/createHospitalOrPracticeWorkflow`, data)
  }

  getAdminEmailExist(email): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/admin/hospital/getHospitalEmailExists`, { email })
      .map(data => data)
  }

  demositmap(): Observable<any> {
    let self = this;
    return self.apiService.get(`/api/v2/admin/demoSetupInvoke`)
  }

  getAuditDetails(): Observable<[any]> {
    let self = this;
    return self.apiService.get('/api/v2/admin/getUserLoginAuditList');
  }



}
